export * from './marginal-analysis-form.component';
